export default __webpack_public_path__ + "static/media/review.3ccef7dd.jpg";